import {i18n} from '@online-offer/i18n';
import {HStack, Show, Text} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

import {isNotNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {FinancialProductOffer} from '../../api/types/onlineOfferTypes';
import {getFinancialProductValidUntilLabel} from './getFinancialProductValidUntilLabel';

interface FinancialProductProviderFactsProps {
  offer: FinancialProductOffer;
}

export function FinancialProductProviderFacts(props: FinancialProductProviderFactsProps) {
  const formatDateTime = useDateTimeFormatter();
  const validUntil = getFinancialProductValidUntilLabel(props.offer.validTo, formatDateTime);

  return (
    <HStack spacing={2} align="center" wrap>
      <Show when={!isNilOrEmpty(props.offer.providerName)}>
        <Text size="base" color="secondary">
          {i18n.t('financialProducts.providedBy')}
        </Text>
        <Text size="base" alternative overflowWrap="anywhere">
          {props.offer.providerName}
        </Text>
      </Show>
      <Show when={isNotNil(validUntil)}>
        <Text size="base" color="secondary">
          {validUntil}
        </Text>
      </Show>
    </HStack>
  );
}
